var chunkMapping = {
	"build_node_index_js-build_node_assets_amd-splash-image_png-build_node_assets_backgrounds_Hero-4950b7": [
		"webpack/container/remote/@do/seashell/graphql",
		"webpack/container/remote/@do/walrus",
		"webpack/container/remote/@do/seashell/navigation",
		"webpack/container/remote/@do/seashell",
		"webpack/container/remote/@do/seashell/experimentation"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/@do/seashell/graphql": [
		"default",
		"./graphql",
		"webpack/container/reference/@do/seashell"
	],
	"webpack/container/remote/@do/walrus": [
		"default",
		".",
		"webpack/container/reference/@do/walrus"
	],
	"webpack/container/remote/@do/seashell/navigation": [
		"default",
		"./navigation",
		"webpack/container/reference/@do/seashell"
	],
	"webpack/container/remote/@do/seashell": [
		"default",
		".",
		"webpack/container/reference/@do/seashell"
	],
	"webpack/container/remote/@do/seashell/experimentation": [
		"default",
		"./experimentation",
		"webpack/container/reference/@do/seashell"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}